
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 80 80"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"fill":"#F0A53D","d":"M40.17 31.543c5.247 0 9.5-4.375 9.5-9.771 0-5.397-4.253-9.772-9.5-9.772s-9.5 4.375-9.5 9.772c0 5.396 4.253 9.771 9.5 9.771z"}}),_c('path',{attrs:{"fill":"#EAD4AA","d":"M20.542 31.543c3.404 0 6.163-2.838 6.163-6.34 0-3.5-2.76-6.339-6.163-6.339-3.404 0-6.164 2.839-6.164 6.34s2.76 6.34 6.164 6.34zm39.099 0c3.404 0 6.164-2.838 6.164-6.34 0-3.5-2.76-6.339-6.164-6.339s-6.163 2.839-6.163 6.34 2.76 6.34 6.163 6.34zM59.673 36c-2.632 0-5.028.915-6.992 2.428a18.34 18.34 0 015.342 12.975v8.517h8.996c2.317 0 4.203-1.91 4.203-4.258v-7.92C71.262 41.253 66.076 36 59.673 36zM21.884 52.279c0-5.453 2.2-10.349 5.657-13.851C25.616 36.955 23.22 36 20.588 36 14.185 36 9 41.254 9 47.741v8C9 58.09 10.886 60 13.203 60h8.642v-7.721h.04z"}})]),_c('path',{attrs:{"fill":"#F0A53D","d":"M55.667 63.002c0 2.756-1.963 4.998-4.375 4.998H28.93c-2.412 0-4.374-2.242-4.374-4.998V54.78c0-9.624 6.296-18.266 14.717-18.733.286 0 .838-.047.818-.047 8.585 0 15.535 7.942 15.535 17.752l.04 8.248v1.002z"}}),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h62.222v50.796H0z","transform":"translate(9 12)"}})])])])
          )
        }
      }
    